/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/scalb.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns the result of `d * 2 ^ scaleFactor`,\nSimilar to Java\'s `scalb` function. Result is rounded as if\nperformed by a single correctly rounded floating-point multiply\nto a member of the double value set.',
  examples: [
    'row x = 3.0, y = 10 | eval z = scalb(x, y)',
  ],
  params: {
    d: 'Numeric expression for the multiplier. If `null`, the function returns `null`.',
    scaleFactor: 'Numeric expression for the scale factor. If `null`, the function returns `null`.',
  },
};

export default docs;
